export default __webpack_public_path__ + "static/media/homeArtistSample.2af1f265.jpeg";